import React, { useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useImporterCsv } from '../hooks/useEmployes';

export function EmployeImportPage() {
  const navigate = useNavigate();
  const importer = useImporterCsv();
  const inputRef = useRef<HTMLInputElement>(null);
  const [fichierSelectionne, setFichierSelectionne] = useState<File | null>(null);
  const [dragOver, setDragOver] = useState(false);

  const handleDrop = (e: React.DragEvent) => {
    e.preventDefault();
    setDragOver(false);
    const f = e.dataTransfer.files[0];
    if (f?.name.endsWith('.csv')) setFichierSelectionne(f);
  };

  const handleImport = async () => {
    if (!fichierSelectionne) return;
    await importer.mutateAsync(fichierSelectionne);
  };

  return (
    <div className="p-6 max-w-xl mx-auto">
      <h1 className="text-2xl font-bold text-content mb-6">Importer des employés (CSV)</h1>

      <div className="bg-surface rounded-lg border border-border p-6 space-y-5">
        {/* Zone drag & drop */}
        <div
          onDragOver={e => { e.preventDefault(); setDragOver(true); }}
          onDragLeave={() => setDragOver(false)}
          onDrop={handleDrop}
          onClick={() => inputRef.current?.click()}
          className={`border-2 border-dashed rounded-lg p-8 text-center cursor-pointer transition-colors ${
            dragOver ? 'border-blue-400 bg-blue-50' : 'border-border hover:border-border-strong'
          }`}
        >
          <input ref={inputRef} type="file" accept=".csv" className="hidden" onChange={e => setFichierSelectionne(e.target.files?.[0] ?? null)} />
          <p className="text-content-muted text-sm">
            {fichierSelectionne ? (
              <span className="text-accent font-medium">📄 {fichierSelectionne.name}</span>
            ) : (
              <>Glissez un fichier CSV ici ou <span className="text-accent">parcourir</span></>
            )}
          </p>
        </div>

        {/* Résultat */}
        {importer.data && (
          <div className="p-4 bg-success-light rounded border border-success">
            <p className="font-medium text-success text-sm">✅ {importer.data.crees} employé(s) créé(s)</p>
            {importer.data.erreurs.length > 0 && (
              <ul className="mt-2 text-xs text-danger space-y-1">
                {importer.data.erreurs.map((e: { ligne: number; message: string }, i: number) => (
                  <li key={i}>Ligne {e.ligne} : {e.message}</li>
                ))}
              </ul>
            )}
          </div>
        )}

        {importer.isError && (
          <p className="text-danger text-sm bg-danger-light p-3 rounded">{(importer.error as any)?.message ?? 'Erreur'}</p>
        )}

        <div className="flex gap-3">
          <button
            onClick={handleImport}
            disabled={!fichierSelectionne || importer.isPending}
            className="flex-1 bg-blue-600 text-white py-2 rounded font-medium hover:bg-blue-700 disabled:opacity-50"
          >
            {importer.isPending ? 'Import...' : 'Importer'}
          </button>
          <button onClick={() => navigate(-1)} className="px-4 py-2 border border-border rounded text-sm hover:bg-surface-raised">
            Annuler
          </button>
        </div>
      </div>
    </div>
  );
}
